// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "." + {"140": "88121497922b4a1f","232": "bbb455f08b617da8","289": "6ffd926d6b48db9b","335": "e06c8db102036cb2","339": "dfb20edb2add46db","383": "a65c4a5debe9d494","562": "b471dff68e657bcf","666": "26e0167b4d15b729","721": "31566547ebeb65dd","918": "29eeafb670278761","924": "374b632c14c94856",}[chunkId] + ".js"
}